<template lang="pug">
  merge-item-row(show-divider align="start")
    template(#secondColumn)
      merge-patient-dropdown(:value="mergeFromPatient" title="Merge from" @input="handleMergeFromPatientChange")
    template(#thirdColumn)
      merge-patient-dropdown(:value="mergeIntoPatient" title="Merge into" :error-message="errorMessage" @input="handleMergeIntoPatientChange")
</template>

<script>
import MergeItemRow from "@/components/clinic/patient/merge/MergeItemRow.vue";
import MergePatientDropdown from "@/components/clinic/patient/merge/MergePatientDropdown.vue";

export default {
  components: {MergePatientDropdown, MergeItemRow},
  props: {
    mergeFromPatient: {
      type: Object,
      default: null
    },
    mergeIntoPatient: {
      type: Object,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    }
  },
  methods: {
    handleMergeFromPatientChange(item) {
      this.$emit('update:mergeFromPatient', item)
    },
    handleMergeIntoPatientChange(item) {
      this.$emit('update:mergeIntoPatient', item)
    }
  },
}
</script>

<style scoped>

</style>